import { render } from "./sort.vue?vue&type=template&id=125c814e&scoped=true"
import script from "./sort.vue?vue&type=script&lang=js"
export * from "./sort.vue?vue&type=script&lang=js"

import "./sort.vue?vue&type=style&index=0&id=125c814e&scoped=true&lang=scss"

import exportComponent from "/home/adachi/omega-base/omega/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-125c814e"]])

export default __exports__